import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 mb-6 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              {t('back_to_home')}
            </button>

            <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-6">
              Privacy Policy
            </h1>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-6">
              <p>
                At CSSBuy Spreadsheet, we value your privacy and are committed to protecting your personal information. This privacy policy explains how we collect, use, and protect data when you visit our website.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Information We Collect</h2>
              <p>We may collect the following types of information:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li><strong>Usage Data:</strong> We use basic analytics to understand how visitors use our website, including page views and referral sources. This data is anonymized and does not identify individual users.</li>
                <li><strong>Contact Information:</strong> If you use our contact form, we collect your name, email address, and message content. This information is used solely to respond to your inquiry.</li>
                <li><strong>Cookies:</strong> We use minimal cookies for language preferences and basic website functionality. We do not use tracking cookies for advertising purposes.</li>
              </ul>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">How We Use Your Information</h2>
              <p>We use the information we collect for the following purposes:</p>
              <ul className="list-disc pl-5 space-y-2">
                <li>To provide and maintain our website services</li>
                <li>To respond to your inquiries and contact requests</li>
                <li>To improve our website content and user experience</li>
                <li>To analyze website usage patterns for optimization</li>
              </ul>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Third-Party Services</h2>
              <p>
                This website may contain links to external websites (such as kaspreadsheet.com). We are not responsible for the privacy practices or content of these external websites. We encourage you to review the privacy policies of any external websites you visit.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Data Security</h2>
              <p>
                We take reasonable measures to protect your information from unauthorized access, alteration, or disclosure. However, no internet transmission is completely secure, and we cannot guarantee absolute security of data transmitted through our website.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Your Rights</h2>
              <p>
                You have the right to access, correct, or delete any personal information we have collected about you. If you would like to exercise these rights, please contact us through our contact page.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Changes to This Policy</h2>
              <p>
                We may update this privacy policy from time to time. Any changes will be posted on this page with an updated date. We encourage you to review this policy periodically.
              </p>

              <p className="text-sm text-foreground-500 mt-8">
                Last updated: August 27, 2026
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}